import { Timestamp } from 'firebase/firestore';

export interface NotificationRule {
  id: string;
  name: string;
  type: NotificationValue;
  severity: NotifSeverity;
  accountId: string;
  formulaId: string;
  created_at: Timestamp;
  enabled: boolean;
  condition: string;
  assignee: string;
  assignees: Record<string, { user: string; email?: string; options: Record<string, boolean> }>;
  expireHours: number;
  sendEveryDays: number;
  options?: Record<string, string | boolean>;
}

export type NotifSeverity = 'notify' | 'operation' | 'warning';
export const notifSeverities: NotifSeverity[] = ['notify', 'operation', 'warning'];

export type NotificationValue =
  | 'all'
  | 'balance_limit'
  | 'price_target'
  | 'backwardation'
  | 'contango'
  | 'logistic'
  | 'coverage'
  | 'buffer';

export const notificationTypes: { value: NotificationValue; label: string }[] = [
  { value: 'balance_limit', label: 'Balance Limit' },
  { value: 'backwardation', label: 'Backwardation' },
  { value: 'contango', label: 'Contango' },
  { value: 'price_target', label: 'Price Target' },
];
